import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b94c7af6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-interpreter" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "field-list-item" }
const _hoisted_4 = {
  key: 0,
  class: "field-tip"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "field-list-item" }
const _hoisted_10 = {
  key: 0,
  class: "field-tip"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select one", -1))
const _hoisted_13 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormStructureInterpreter = _resolveComponent("FormStructureInterpreter", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSelectNode && !_ctx.isAnswerNode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.field.fieldLabel), 1),
            (_ctx.field.tip)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("i", null, _toDisplayString(` (${_ctx.field.tip})`), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.emailSummaryValue)
              ? (_openBlock(), _createElementBlock("b", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" [" + _toDisplayString(_ctx.emailSummaryValue) + "] ", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAnswerNode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.children, (childField) => {
            return (_openBlock(), _createElementBlock("div", {
              key: childField.fieldId,
              class: "child-field"
            }, [
              _createVNode(_component_FormStructureInterpreter, {
                field: childField,
                emailSummary: _ctx.emailSummary,
                depth: _ctx.depth
              }, null, 8, ["field", "emailSummary", "depth"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSelectNode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.field.fieldLabel), 1),
            (_ctx.field.tip)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createElementVNode("i", null, _toDisplayString(` (${_ctx.field.tip})`), 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_11
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedAnswerValue = $event)),
            class: "question-dropdown"
          }, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.children, (answer) => {
              return (_openBlock(), _createElementBlock("option", {
                key: answer.answerValue,
                value: answer.answerValue
              }, _toDisplayString(answer.answerLabel), 9, _hoisted_13))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedAnswerValue]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.children, (childField) => {
            return (_openBlock(), _createElementBlock("div", {
              key: childField.answerValue,
              class: "answer-field"
            }, [
              _withDirectives(_createVNode(_component_FormStructureInterpreter, {
                id: `js-answer-interpreter-${childField.answerValue}-${_ctx.depth + 1}`,
                field: childField,
                emailSummary: _ctx.emailSummary,
                depth: _ctx.depth + 1
              }, null, 8, ["id", "field", "emailSummary", "depth"]), [
                [_vShow, _ctx.selectedAnswerValue === childField.answerValue]
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}